import ViewByCompany from "@/components/dashboard/ViewByCompany";
import { useSidebarLayout } from "@/hooks/useSidebarLayout";

export default function Companies() {
  const { getPageHeaderClass } = useSidebarLayout();
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Fixed Page Header - single line */}
      <div className={getPageHeaderClass()}>
        <div className="h-full flex items-center px-6">
          <h1 className="text-2xl font-semibold text-gray-900">Project Companies</h1>
        </div>
      </div>
      
      {/* Main Content with proper top padding to account for fixed header (64px global + 64px page = 128px = pt-32) */}
      <main className="pt-32 pb-8 px-4 sm:px-6 lg:px-8 max-w-full mx-auto">
        <ViewByCompany />
      </main>
    </div>
  );
}
